<template>
    <div>
        <h1>Administrador de Prospecting</h1>
        <p>Aquí puedes ver todas las aplicaciones Prospecting registradas. Pero antes que nada puedes:</p>
        
        <div>
            <div  class="uk-margin">
                <input type="password" class="uk-input" v-model="pass" placeholder="Ingresa la contraseña de entrada">
            </div>
        </div>
        <div  v-if="pass == 'integral'">
            <div class="uk-child-width-1-2@s" uk-grid>
                <div>
                    <button uk-toggle="target: #new" class="uk-button uk-button-primary uk-button-large">Crear nueva app Prospecting</button>
                </div>
                <div>
                    <button v-on:click="saveTel"  class="uk-button uk-button-primary uk-button-large"> Guardar Whatsapp</button>
                </div>
            </div>
    	
    	<table class="uk-table uk-table-striped uk-table-hover">
            <thead>
                <tr>
                    <th>
                        Identificador
                    </th>
                    <th>
                        Prospectos
                    </th>
                    <th>
                        Ver Prospectos
                    </th>
                    <th>
                        Whatsapp
                    </th>
                    <th>
                        Liga (copia, pega y envía. Así de fácil)
                    </th>
                    <th>
                        Liga de prospectos (para que la coop vea sus prospectos)
                    </th>
                    <th>
                        Eliminar
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item, index in data">
                    <td>
                        {{index}}
                    </td>
                    <td>
                        {{Object.keys(item).length -1   }}
                    </td>
                    <td>
                        <a :href="'https://integral-apps.web.app/prospec/prospects?f='+index" class="uk-button uk-button-secondary">Ver Prospectos</a>
                    </td>
                    <td>
                        <input type="tel" class="uk-input" placeholder="Whatsapp" v-model="item.telefono">
                    </td>
                    <td>
                        <a class="uk-link-text" :href="'https://integral-apps.web.app/prospec?f='+index">{{'https://integral-apps.web.app/prospec?f='+index}}</a>
                    </td>
                    <td>
                        <a class="uk-link-text" :href="'https://integral-apps.web.app/prospec/prospects?f='+index">{{'https://integral-apps.web.app/prospec/prospects?f='+index}}</a>
                    </td>
                    <td>
                        <button uk-toggle="target: #delete" v-on:click="toDelete = index"><span uk-icon="icon:trash;ratio:2"></span></button>
                    </td>
                </tr>
            </tbody>
        </table>

        <h3><i>Siempre estoy cargando nuevos Prospecting...</i></h3>





        </div>

<div id="new" uk-modal>
    <div class="uk-modal-dialog uk-modal-body">
        <button class="uk-modal-close-default" type="button" uk-close></button> 
        <h2 class="uk-modal-title">Crear nueva Prospecting</h2>
        <form id="form" >
            <div class="uk-margin">
                <input type="text" class="uk-input" v-model="id" placeholder="Identificador de la institución">
            </div>
            <div class="uk-margin">
                <input type="tel" class="uk-input"  v-model="tel" placeholder="Teléfono (Whatsapp) de la institución">
            </div>
            <div class="uk-margin">
                <label >Sube el logo de la institución <br></label>
                <input type="file" id="logo" v-on:change="createLogo">
                
                            <div class="uk-text-left uk-margin-medium-left" v-if="logo">
                                <p style="font-size:17px"><br> <b> Archivo seleccionado: </b></p>
                                <ul>
                                    <li >
                                        {{logo}}
                                    </li>
                                </ul>
                            </div>
            </div>
            <div class="uk-margin">
                <label >Sube las publicidades en forma de imagen <br></label>
                <input type="file" id="ads" v-on:change="createFiles" multiple>
                
                            <div class="uk-text-left uk-margin-medium-left" v-if="ads">
                                <p style="font-size:17px"><br> <b> Archivos seleccionados: </b></p>
                                <ul>
                                    <li v-for="it, ind in ads">
                                        {{it}}
                                    </li>
                                </ul>
                            </div> 
            </div>
        </form>
        <button class="uk-modal-close uk-button uk-button-primary" v-on:click="createProspecting" type="button">Crear prospecting</button>
    </div>
</div>

<div id="delete" uk-modal>
    <div class="uk-modal-dialog uk-modal-body">
        <h2 class="uk-modal-title">Borrar Prospecting</h2>
        <p><b>¿Estás seguro de que deseas borrar este Prospecting?</b><br>La liga de esta institución direccionará a la versión de demostración</p>
        <button class="uk-button uk-button-primary uk-modal-close " v-on:click="deleteProspecting" type="button">Borrar</button>
        <button class=" uk-modal-close uk-button uk-button-default">Cancelar</button>
    </div>
</div>



    </div>
</template>

<script>
export default {
    data : function () {
        return {
            data  : {},
            pass: '',
            toDelete : '',
            tel : '',
            ads : [],
            logo : '',
            id : '',
            logoFile : null,
            adFiles : null,
        }
    },
    watch: {
    },
    methods:{
        createLogo : function (old) {
            this.logoFile = document.getElementById('logo').files[0]
            this.logo = this.logoFile.name
        },
        createFiles : function (old) {
            this.ads = []
            this.adFiles = document.getElementById('ads').files
           for(var i in this.adFiles) {
               if(Boolean(this.adFiles[i].name) && this.adFiles[i].name    != 'item')
               this.ads.push(this.adFiles[i].name)
           }
        },
        createProspecting : async function () {
            // Crear prospecting
            UIkit.notification('Creando prospecting...','warning')       
            var st = firebase.storage().ref('000 APPS/prospecting/'+ this.id)
            await st.child('logo.jpg').put(this.logoFile)
            UIkit.notification('Espera... Se están subiendo las imágenes','warning')  
            for(var i in this.adFiles){
               if(Boolean(this.adFiles[i].name) && this.adFiles[i].name    != 'item')
                await st.child(this.adFiles[i].name).put(this.adFiles[i])
            }
            var data = {
                telefono : this.tel,
                admin : {
                    'kcY6bUCkJtNrL4su9oM1fnDZCVr1' : {data : 'some'}
                }
            }
            await firebase.database().ref('apps/prospecting/'+this.id).update(data)
            UIkit.notification('Prospecting creado correctamente! <br> Búscalo en la lista con su identificador','success')
        


        },
        deleteProspecting : function () {
            // Borrar Prospecting
            delete this.data[this.toDelete]
            firebase.database().ref('apps/prospecting/').set(this.data)
            UIkit.notification('Prospecting borrado correctamente')
        },
        saveTel:function () {
            // Guardar cambios en tels
            firebase.database().ref('apps/prospecting/').update(this.data)
            UIkit.notification('Cambios guardados corretamente','success')
        },
    }, 
    mounted : async function (){
          await firebase.auth().signInWithEmailAndPassword('7c@maill.com','123456')
        firebase.database().ref('apps/prospecting').on('value', function (s) {
            var d = s.toJSON()
            this.data = {}
            for (var i in d){
                this.$set(this.data, i, d[i])
            }   
        }.bind(this))
    }
}
</script>